module.exports = __webpack_public_path__ + "1a0e4d72ce1470a7b7b1175809d97c7a.png";